import api from "@/api/axios";

export default {
  getAll(type, params = {}) {
    return api.get(`/${type}`, { params });
  },

  getOne(type, id) {
    return api.get(`/${type}/${id}`);
  },

  create(type, data) {
    return api.post(`/${type}`, data);
  },

  update(type, id, data) {
    return api.put(`/${type}/${id}`, data);
  },

  delete(type, id) {
    return api.delete(`/${type}/${id}`);
  },
};
